import { ROUTES } from "@/shared/constants/routes";
import ProtectedRoute from "@/shared/components/ProtectedRoute";
import { RouteObject } from "react-router-dom";
import TPRADashboard from "../components/TPRADashboard";

export const TPRADashboardRoutes: RouteObject[] = [
  {
    path: ROUTES.TPRA_DASHBOARD,
    element: (
      <ProtectedRoute featureName="tpraDashboard">
        <TPRADashboard />
      </ProtectedRoute>
    ),
  },
];
